// @flow

import { SHOW_CONFIG_VALIDATION_ERRORS } from './constants';
import { getUiSetting } from '../index';

export const shouldShowErrors = (state: any) => getUiSetting(state, SHOW_CONFIG_VALIDATION_ERRORS);

export default null;
